import React from 'react';
import { VStack } from 'native-base';
import { Section } from '~/shared/Theme';
import { Caption, H1 } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';

export const LocationPermission = () => {

    const { primary } = useTheme();

    return (
        <Section p={4}>
            <VStack
                h={'full'}
                justifyContent={'center'}
                alignItems={'center'}
                textAlign={'center'}
                space={8}
            >
                <H1 text={'shop.grant_location_permission'} />
                <SpIcon
                    color={primary}
                    icon={faCompass}
                    size={100}
                />
                <Caption
                    text={'shop.location_permissions_are_required'}
                />
                <Caption
                    text={'shop.permissions_can_be_reset'}
                />
            </VStack>
        </Section>
    );
};
